'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var getCurrentUrl = exports.getCurrentUrl = function getCurrentUrl() {
  if (typeof window !== 'undefined') {
    return '' + window.location.origin + window.location.pathname;
  }
};

var getCurrentHref = exports.getCurrentHref = function getCurrentHref() {
  if (typeof window !== 'undefined') {
    return '' + window.location.href;
  }
};

var getIsMobile = exports.getIsMobile = function getIsMobile() {
  if (typeof window !== 'undefined') {
    return navigator.userAgent.match(/Android|iPhone|iPad|iPod/i);
  }
};

var isFacebookApp = exports.isFacebookApp = function isFacebookApp() {
  if (typeof window !== 'undefined') {
    return navigator.userAgent.match(/FBAV|FBAN/i);
  }
};